exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-scroller {\n  height: 18px;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  background-color: #eeeeee;\n  position: relative;\n  top: 0;\n  z-index: 3; }\n  .top-scroller > div {\n    overflow-x: scroll;\n    visibility: hidden; }\n\n.top-scroller::-webkit-scrollbar {\n  width: 17px;\n  height: 17px;\n  background: #f1f1f1; }\n\n.top-scroller::-webkit-scrollbar-thumb {\n  background: #999;\n  border-radius: 2px; }\n\n.top-scroller::-webkit-scrollbar-track {\n  width: 15px; }\n\n.top-scroller::-webkit-scrollbar-track-piece:end,\n.top-scroller::-webkit-scrollbar-track-piece:start {\n  background: transparent; }\n\n.tableHeader {\n  background-color: #fff;\n  position: absolute;\n  z-index: 2; }\n\n.tableHeader::-webkit-scrollbar, .mainTable::-webkit-scrollbar, .mainDiv::-webkit-scrollbar {\n  display: none; }\n\n.scrollable {\n  width: 100%;\n  overflow-x: scroll;\n  overflow-y: hidden; }\n\n.scrollable::-webkit-scrollbar {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/dolarizacion/dolarizacion.component.scss
// module id = ../../../../../src/app/components/administracion/dolarizacion/dolarizacion.component.scss
// module chunks = 0